const moment = require('moment');

const urlFrontend=()=>{
	//return "http://127.0.0.1:3000/aset";
	return "http://156.67.219.84:8123/aset";
}

const urlBackend=()=>{
	return process.env.REACT_APP_API_URL+"/stok/api/v2/";
}


const urlPrint=()=>{
	return process.env.REACT_APP_API_URL+"/print/";
}

const urlBarcode=()=>{
	return process.env.REACT_APP_API_URL+"/api/v1/qrcode";
}

const urlStorage=()=>{
	return process.env.REACT_APP_API_URL+"/storage/";
}

const getNow=()=>{
	return moment().format('YYYY-MM-DD');
}

const saveTanggal=(param)=>{
	var respon="";
	if(param){
		respon=moment(param).format('YYYY-MM-DD');
	}
	return respon;
}

const saveTanggalIndo=(param)=>{
	var respon="";
	if(param){
		let ar = param.split('-');
		respon = ar[2]+"-"+ar[1]+"-"+ar[0];
	}
	return respon;
}

const showTanggalIndo=(param)=>{
	var respon="";
	if(param){
		respon=moment(param).format('DD-MM-YYYY');
	}
	return respon;
}

const showTanggal=(param)=>{
	var respon="";
	if(param){
		respon=moment(param).format('DD/MM/YYYY');
	}
	return respon;
}

const showTanggalJam=(param)=>{
	var respon="";
	if(param){
		respon=moment(param).format('DD/MM/YYYY HH:mm:ss');
	}
	return respon;
}

const limitDefault =()=>{
	return 1000
}


const removeNone=(param)=>{
	if(param){
	if(param.includes('None')){
		param =  param.replace('None','-');
	}
	}
	return param;
}

const exportTanggalDefault=(param)=>{
	var respon="";
	if(param){
		respon=moment(param).format('YYYY-MM-DD');
	}
	return respon;
}

const toAngka = (x)=>{
	var result = x;
	if(x){
		if(typeof x == "string" && x.indexOf(',') > -1){
			result = x.replace(/\,/g,'');
		}
	}else{
		result = 0;
	}
	return result;
}

const showRole = (param)=>{
	var respon = "";
	if(param==1){
		respon="Admin";
	}else{
		respon="Operator";
	}
	return respon;
}

const showInOut = (param) =>{
	var respon = "";
	if(param=="IN"){
		respon = <div className='badge bg-success' style={{fontSize:'12px', color:"white"}}>IN</div>;
	}else{
		respon = <div className='badge bg-danger' style={{fontSize:'12px', color:"white"}}>OUT</div>;
	}
	return respon;
}

const showStatusProses = (param) =>{
	var respon = "";
	switch(param){
		case "00":
			respon = <div className='badge bg-warning' style={{fontSize:'12px', color:"white"}}>Patrun</div>;
		break;

		case "01":
			respon = <div className='badge bg-warning' style={{fontSize:'12px', color:"white"}}>Sewing</div>;
		break;

		case "02":
			respon = <div className='badge bg-warning' style={{fontSize:'12px', color:"white"}}>Beading</div>;
		break;

		case "20":
			respon = <div className='badge bg-success' style={{fontSize:'12px', color:"white"}}>Ready</div>;
		break;

		case "99":
			respon = <div className='badge bg-danger' style={{fontSize:'12px', color:"white"}}>Cancel</div>;
		break;
	}
	return respon;
}

const showStatusAktif = (param)=>{
	var respon = "";
	if(param=='Y'){
		respon = <div className='badge bg-success' style={{fontSize:'12px', color:"white"}}>Aktif</div>;
	}else{
		respon = <div className='badge bg-danger' style={{fontSize:'12px', color:"white"}}>Tidak Aktif</div>;
	}
	return respon;
}

const infoSession=(params)=>{
    var respon="";
    switch(params){
        case "id":
        	var token=sessionStorage.getItem('ses_mogi');
        	var spx=token.split('.');
      		var body = atob(spx[1]);
      		var data=JSON.parse(body);
        	respon=data.id;
        break;

		case "nama":
			var token=sessionStorage.getItem('ses_mogi');
        	var spx=token.split('.');
      		var body = atob(spx[1]);
      		var data=JSON.parse(body);
        	respon=data.nama;
		break;

		case "role":
			var token=sessionStorage.getItem('ses_mogi');
        	var spx=token.split('.');
      		var body = atob(spx[1]);
      		var data=JSON.parse(body);
        	respon=data.id_role;
		break;

		
    }

    return respon;

}

const jsonToUpperCase=(data)=>{ 
	for(var i = 0; i < data.length; i++){ 
  		for (var key in data[i]) {
   			if(key.toUpperCase() !== key){
    			data[i][key.toUpperCase()] = data[i][key];
    			delete data[i][key];
   			}
  		}
 	}
 return data;  
}

const showTanggalHuruf=(data)=>{
	var data=new Date(data);
	var tahun = data.getFullYear();
	var bulan = data.getMonth();
	var tanggal = data.getDate();

	bulan=showBulan(bulan);
	return tanggal+" "+bulan+" "+tahun;
}

const showHari=(params)=>{
	switch(params){
		case 0:
			return "Minggu";
		break;

		case 1:
			return "Senin";
		break;

		case 2:
			return "Selasa";
		break;

		case 3:
			return "Rabu";
		break;

		case 4:
			return "Kamis";
		break;

		case 5:
			return "Jumat";
		break;

		case 6:
			return "Sabtu";
		break;
	}
}

const showBulan=(params)=>{
	switch(params){
		case 0:
			return "Januari"; 
		break;

		case 1:
			return "Februari";
		break;

		case 2:
			return "Maret";
		break;

		case 3:
			return "April";
		break;

		case 4:
			return "Mei";
		break;

		case 5:
			return "Juni";
		break;

		case 6:
			return "Juli";
		break;

		case 7:
			return "Agustus";
		break;

		case 8:
			return "September";
		break;

		case 9:
			return "Oktober";
		break;

		case 10:
			return "November";
		break;

		case 11:
			return "Desember";
		break;
	}
}

const defaultConfig=(param)=>{
	//console.log(param);
	var respon="";
	var data=JSON.parse(sessionStorage.getItem('defaultConfig'));
	data.map((item, index)=>{
		if(item.id_config==param){
			respon= item.nilai_config;
		}
	});
	//console.log(respon);
	return respon;
}

const formatBytes = (bytes, decimals = 2) =>{

	if(bytes){
	    if (bytes === 0) return '0 Bytes';

	    const k = 1024;
	    const dm = decimals < 0 ? 0 : decimals;
	    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

	    const i = Math.floor(Math.log(bytes) / Math.log(k));

	    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
	}else{
		return '0 Bytes';
	}
}

const getLabelCombo = (params) =>{
    var respon="";
    if(params){
        var ar=params.split("-");
        respon=ar[1].trim();
    }
    return respon;
}


const formatUang=(x)=>{
  var result=x;
    if(x){
      var xx=eval(parseInt(x))
      var parts = xx.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      result=parts.join(".");
    }
  return result;
}

const angkaToUang=(nominal)=>{
  var respon=0;
  if(nominal){
    if(nominal.toString().indexOf('.')>-1){
      nominal=nominal.toString().replace('.',',');
      var ar=nominal.toString().split(',');
      respon=this.formatUang(ar[0]+","+ar[1]);
    }else{
      respon=this.formatUang(nominal);
    }
  }
  return respon;
}

export{
	limitDefault,
	urlFrontend,
	urlBackend,
	urlStorage,
	exportTanggalDefault,
	angkaToUang,
	toAngka,
	infoSession,
	jsonToUpperCase,
	getNow,
	saveTanggal,
	showTanggal,
	showTanggalJam,
	saveTanggalIndo,
	showTanggalHuruf,
	showTanggalIndo,
	urlPrint,
	defaultConfig,
	formatBytes,
	getLabelCombo,
	urlBarcode,
	removeNone,

	showRole,
	showStatusAktif,
	showStatusProses,
	showInOut
}
